import React from "react";
import { FormRuntime } from "../../FormRuntime";
import { DataGridFormControl } from "../Web/DataGridFormControl";
import { XStackContainer } from "../../Containers";
import { FormConfiguration } from "../../FormConfiguration";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

function getUI(): { form: FormConfiguration; control: DataGridFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    ui.add(container);

    let datagrid = new DataGridFormControl();
    datagrid.label = "Datagrid With Configuration";
    datagrid.valueName = "employee";
    datagrid.selectedValueName = "selectedEmployee";
    datagrid.selectedColumnSet = 0;
    datagrid.columnValues = [
        {
            field: "Name",
            headerName: "Name",
            type: "string",
            width: 180,
            sortable: false,
            filterable: false,
        },
        {
            field: "Age",
            headerName: "Age",
            type: "number",
            width: 160,
            sortable: false,
            filterable: false,
        },
        {
            field: "IsMale",
            headerName: "IsMale",
            type: "boolean",
            sortable: false,
            filterable: false,
        },
    ];

    container.add(datagrid);

    return { form: ui, control: datagrid };
}

let data = new ExecutionData();
data.values["employee"] = [
    {
        Name: "John",
        Age: 28,
        IsMale: true,
    },
    {
        Name: "Cathy",
        Age: 25,
        IsMale: false,
    },
    {
        Name: "James",
        Age: 32,
        IsMale: true,
    },
    {
        Name: "Majesta",
        Age: 28,
        IsMale: true,
    },
];

export const DataGridStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataGridMode = "Display";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Display Mode",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataGridMode = "Edit";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Edit Mode",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataGridMode = "Select";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Select Mode",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataGridMode = "Select & Edit";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Select and Edit Mode",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.columnValues[0].hide = true;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Hide Col Feature",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.columnValues[0].sortable = true;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Sort Col Feature",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.columnValues[0].sortable = true;
            ui.control.columnValues[1].sortable = true;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Multi-Sort Col Feature",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.columnValues[0].filterable = true;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Filter Feature",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.columnValues[0].width = 250;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Col Width",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.columnValues[0].customHeader = true;
            ui.control.columnValues[0].fontColor = UIStyleConstants.RED_COLOR;
            ui.control.columnValues[0].fontSize = 20;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Data Grid",
        "Header Color and Font",
    ),
];
